import React, { useRef, useState } from "react";
import "./GestionDepotOffreActions.scss";
import PropTypes from "prop-types";
import { Menu } from "primereact/menu";
import BtnRond from "Components/Boutons/BtnRond/btn-rond";
import { FaEllipsisH } from "react-icons/fa";
import { connect } from "react-redux";
import Modal from "Components/Modal/Modal";
import { InputTextarea } from "primereact/inputtextarea";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import axios from "axios";
import { updateOffers } from "Redux/Actions/offersActions";
import DepotOffre from "../../DepotOffre/DepotOffre";
import { TransmitterIRItoName } from "Services/functions";

const GestionDepotOffreCard = (props) => {
  const menu = useRef(null);
  const [openRefusInterface, setOpenRefusInterface] = useState(false);
  const [openModifyInterface, setOpenModifyInterface] = useState(false);
  const [refus, setRefus] = useState("");
  const [errorRefus, setErrorRefus] = useState(false);
  const [openMotifRefusInterface, setOpenMotifRefusInterface] = useState(false);
  const itemsPublie = [
    {
      label: "Modifier",
      command: () => {
        setOpenModifyInterface(!openModifyInterface);
      },
    },
    { separator: true },
    {
      label: "Supprimer",
      command: () => {
        deleteOffer();
      },
    },
  ];
  const itemsBrouillon = [
    {
      label: "Modifier",
      command: () => {
        setOpenModifyInterface(!openModifyInterface);
      },
    },
    { separator: true },
    {
      label: "Supprimer",
      command: () => {
        deleteOffer();
      },
    },
  ];

  const itemsRefuse = [
    {
      label: "Renouveler la demande",
      command: () => {
        setOpenMotifRefusInterface(!openMotifRefusInterface);
      },
    },
  ];
  const itemsRefuseAdmin = [
    {
      label: "Supprimer",
      command: () => {
        deleteOffer();
      },
    },
  ];

  const itemsAttente = [
    {
      label: "Modifier",
      command: () => {
        setOpenModifyInterface(!openModifyInterface);
      },
    },
    { separator: true },
    {
      label: "Annuler",
      command: () => {
        deleteOffer();
      },
    },
  ];
  const itemsAttenteAdmin = [
    {
      label: "Accepter",
      command: () => {
        modifyStatus("validate");
      },
    },
    { separator: true },
    {
      label: "Refuser",
      command: () => {
        setOpenRefusInterface(!openRefusInterface);
      },
    },
    { separator: true },
    {
      label: "Archiver",
      command: () => {
        modifyStatus("archive");
      },
    },
    { separator: true },
    {
      label: "Modifier",
      command: () => {
        setOpenModifyInterface(!openModifyInterface);
      },
    },
  ];

  const itemsArchive = [
    {
      label: "Accepter",
      command: () => {
        modifyStatus("validate");
      },
    },
    { separator: true },
    {
      label: "Refuser",
      command: () => {
        setOpenRefusInterface(!openRefusInterface);
      },
    },
  ];

  const modifyStatus = (path) => {
    if (!props.offre?.transmitter) return;

    let url = `${process.env.REACT_APP_BASE_URL_API}/offers/${props.id}/${path}`;
    if (
      (typeof props.offre.transmitter === "string" &&
        TransmitterIRItoName(props.offre.transmitter) === "Recruteur") ||
      props.offre.transmitter.name === "Recruteur"
    ) {
      url += "/recruiter";
      // Si on est sur une offre recruteur, on remplace publish par validate
      if (path === "publish") url = url.replace("publish", "validate");
    }

    let data = {};
    if (path === "refuse") data = { feedback: refus };
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        let tempVar = props.offers.dataFromPagination;
        tempVar.data = tempVar.data.map((offer) => {
          if (offer.id === res.data.id) {
            return res.data;
          } else {
            return offer;
          }
        });
        props.handleUpdateOffers({
          dataFromPagination: tempVar,
        });
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  const deleteOffer = () => {
    if (!props.offre?.transmitter) return;

    let url = `${process.env.REACT_APP_BASE_URL_API}/offers/${props.id}`;

    if (
      (typeof props.offre.transmitter === "string" &&
        TransmitterIRItoName(props.offre.transmitter) === "Recruteur") ||
      props.offre.transmitter.name === "Recruteur"
    ) {
      url += "/recruiter";
    }

    axios
      .delete(url, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then(() => {
        let tempVar = props.offers.dataFromPagination;
        tempVar.data = tempVar.data.filter((offer) => offer.id !== props.id);
        props.handleUpdateOffers({
          dataFromPagination: tempVar,
        });
      });
  };

  const Statut = () => {
    switch (props.statut.statusLabel) {
      case "Archivé":
        return itemsArchive;
      case "En Attente":
        switch (props.auth.isAdmin || props.auth.isValidator) {
          case true:
            return itemsAttenteAdmin;
          default:
            return itemsAttente;
        }
      case "Publié":
        return itemsPublie;
      case "Refusé":
        switch (props.auth.isAdmin || props.auth.isValidator) {
          case true:
            return itemsRefuseAdmin;
          default:
            return itemsRefuse;
        }
      case "Brouillon":
        return itemsBrouillon;
      default:
        break;
    }
  };
  return (
    <div className="groupe_menu_offers">
      <div className={`groupe_menu ${props.secondClass}`}>
        <Menu
          appendTo={document.getElementById("app")}
          model={Statut()}
          popup
          ref={menu}
          style={{ textAlign: "center" }}
        />
        <BtnRond btnAction={(event) => menu.current.toggle(event)}>
          <FaEllipsisH size={"1.5rem"} />
        </BtnRond>
      </div>
      {openRefusInterface && (
        <Modal
          visible={openRefusInterface}
          setVisible={setOpenRefusInterface}
          header={`Justifiez votre refus de l'offre`}
        >
          <div className="modal_motif_refus">
            <InputTextarea
              className="modal_refus"
              rows={6}
              placeholder="Justifiez votre refus"
              value={refus}
              onChange={(e) => setRefus(e.target.value)}
            />
            {errorRefus && (
              <span className="error_refus_length">
                Le motif de refus doit faire au moins 10 caractères
              </span>
            )}
            <BtnBleu
              btnTexte="Envoyer"
              btnAction={() => {
                if (refus.length > 9) {
                  setErrorRefus(false);
                  setRefus("");
                  setOpenRefusInterface(false);
                  modifyStatus("refuse");
                } else setErrorRefus(true);
              }}
            />
          </div>
        </Modal>
      )}
      {openMotifRefusInterface && (
        <Modal
          visible={openMotifRefusInterface}
          setVisible={setOpenMotifRefusInterface}
          header={`Motif du refus`}
        >
          <div className="motif_refus_interface">
            <div className="motif_refus_interface_message">
              <span className="motif_refus_interface_message_title">
                Motif du refus :
              </span>
              <span className="motif_refus_interface_message_text">
                {props.feedback
                  ? props.feedback
                  : " Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim maiores vero totam exercitationem at asperiores quibusdam eligendi labore fuga, porro tempora dolor nihil repellat error aut distinctio et earum molestiae accusamus rem."}
              </span>
            </div>
            <div className="motif_refus_interface_bouton">
              <BtnBleu
                btnTexte="Renouveler la demande"
                btnAction={() => {
                  setOpenModifyInterface(true);
                  setOpenMotifRefusInterface(false);
                }}
              ></BtnBleu>
            </div>
          </div>
        </Modal>
      )}
      {openModifyInterface && (
        <Modal
          visible={openModifyInterface}
          setVisible={setOpenModifyInterface}
          header={`Modifiez votre offre`}
        >
          <DepotOffre
            activeIndex={props.items.itemsOffre.findIndex(
              (v) => v.label == "Déposer une offre"
            )}
            paramItems={props.items.itemsOffre}
            offerId={props.offre?.id}
            setVisible={setOpenModifyInterface}
            recruteur={!!props.offre.reference}
          ></DepotOffre>
        </Modal>
      )}
    </div>
  );
};

GestionDepotOffreCard.propTypes = {
  statut: PropTypes.object,
  id: PropTypes.number,
  offre: PropTypes.object,
  feedback: PropTypes.string,
  secondClass: PropTypes.string,

  auth: PropTypes.object,
  offers: PropTypes.object,
  items: PropTypes.object,

  handleUpdateOffers: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  offers: state.offers,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateOffers: (value) => {
    dispatch(updateOffers(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GestionDepotOffreCard);
